module.exports = __webpack_public_path__ + "img/elderly.06b03628.png";